module.exports = __webpack_public_path__ + "img/payment-method-image-01.82229db.svg";